"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _question = _interopRequireDefault(require("./question"));
var _additionalInformation = _interopRequireDefault(require("./additional-information"));
var _career = _interopRequireDefault(require("./career"));
var _certificationOrLicence = _interopRequireDefault(require("./certification-or-licence"));
var _coursework = _interopRequireDefault(require("./coursework"));
var _d1Athletic = _interopRequireDefault(require("./d1-athletic"));
var _diversity = _interopRequireDefault(require("./diversity"));
var _enhancedAcademicExperience = _interopRequireDefault(require("./enhanced-academic-experience"));
var _highSchoolHonor = _interopRequireDefault(require("./high-school-honor"));
var _honor = _interopRequireDefault(require("./honor"));
var _industry = _interopRequireDefault(require("./industry"));
var _jobInterest = _interopRequireDefault(require("./job-interest"));
var _language = _interopRequireDefault(require("./language"));
var _link = _interopRequireDefault(require("./link"));
var _minor = _interopRequireDefault(require("./minor"));
var _otherExperience = _interopRequireDefault(require("./other-experience"));
var _personalInterest = _interopRequireDefault(require("./personal-interest"));
var _preference = _interopRequireDefault(require("./preference"));
var _professionalExperience = _interopRequireDefault(require("./professional-experience"));
var _pronouns = _interopRequireDefault(require("./pronouns"));
var _relevantCoursework = _interopRequireDefault(require("./relevant-coursework"));
var _scholarship = _interopRequireDefault(require("./scholarship"));
var _studyAbroad = _interopRequireDefault(require("./study-abroad"));
var _technicalSkill = _interopRequireDefault(require("./technical-skill"));
var _workEligibility = _interopRequireDefault(require("./work-eligibility"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var _default = _propTypes.default.shape({
  id: _propTypes.default.number,
  universityName: _propTypes.default.string,
  cityOfHomeName: _propTypes.default.string,
  cityOfUniversity: _propTypes.default.string,
  cityOfUniversityName: _propTypes.default.string,
  stateOfHomeName: _propTypes.default.string,
  stateOfHome: _propTypes.default.string,
  countryOfHome: _propTypes.default.string,
  countryOfHomeName: _propTypes.default.string,
  yearGraduation: _propTypes.default.string,
  monthGraduation: _propTypes.default.string,
  firstMajor: _propTypes.default.string,
  firstDegree: _propTypes.default.string,
  firstDegreeName: _propTypes.default.string,
  secondDegree: _propTypes.default.string,
  secondDegreeName: _propTypes.default.string,
  secondMajor: _propTypes.default.string,
  highSchoolName: _propTypes.default.string,
  highSchoolCity: _propTypes.default.string,
  highSchoolCityName: _propTypes.default.string,
  highSchoolState: _propTypes.default.string,
  highSchoolStateName: _propTypes.default.string,
  highSchoolYearGraduation: _propTypes.default.string,
  highSchoolCountryName: _propTypes.default.string,
  actScore: _propTypes.default.string,
  satScore: _propTypes.default.string,
  photoUrl: _propTypes.default.string,
  typeId: _propTypes.default.string,
  typeName: _propTypes.default.string,
  firstMajorName: _propTypes.default.string,
  otherFirstMajor: _propTypes.default.string,
  secondMajorName: _propTypes.default.string,
  otherSecondMajor: _propTypes.default.string,
  thirdMajorName: _propTypes.default.string,
  otherThirdMajor: _propTypes.default.string,
  firstName: _propTypes.default.string,
  middleName: _propTypes.default.string,
  lastName: _propTypes.default.string,
  email: _propTypes.default.string,
  uploadPhotoScreenShowed: _propTypes.default.bool,
  thumb_url: _propTypes.default.string,
  myselfEmoji: _propTypes.default.string,
  heardFromUs: _propTypes.default.string,
  heardFromUsSubOption: _propTypes.default.string,
  heardFromUsExpanded: _propTypes.default.string,
  cityOfHome: _propTypes.default.string,
  countryCityOfHome: _propTypes.default.string,
  stateOfUniversity: _propTypes.default.string,
  stateOfUniversityName: _propTypes.default.string,
  university: _propTypes.default.string,
  phone: _propTypes.default.string,
  receiveUpdates: _propTypes.default.number,
  street: _propTypes.default.string,
  zipCode: _propTypes.default.string,
  specialization: _propTypes.default.string,
  hasMinors: _propTypes.default.string,
  gpa: _propTypes.default.string,
  notPublishGPAS: _propTypes.default.string,
  notHaveGPA: _propTypes.default.string,
  includeGPAOnResume: _propTypes.default.bool,
  includeAdditionalDiversityResume: _propTypes.default.bool,
  includeDiversityInclusionsResume: _propTypes.default.bool,
  hasScholarships: _propTypes.default.string,
  hasHonors: _propTypes.default.string,
  hasStudiesAbroad: _propTypes.default.string,
  internationalHighSchool: _propTypes.default.number,
  highSchoolCountryCity: _propTypes.default.string,
  highSchoolCountry: _propTypes.default.string,
  highSchoolMonthGraduation: _propTypes.default.string,
  includeHighSchoolOnResume: _propTypes.default.bool,
  includeHighSchoolHonorsOnResume: _propTypes.default.bool,
  includeActSatScoreOnResume: _propTypes.default.bool,
  hasEnhancedAcademicExperiences: _propTypes.default.string,
  hasDivisionAthletics: _propTypes.default.string,
  linkedInURL: _propTypes.default.string,
  alternativeEmail: _propTypes.default.string,
  amountProfessionalExperiences: _propTypes.default.number,
  amountOtherExperiences: _propTypes.default.number,
  seeking: _propTypes.default.number,
  firstConcentration: _propTypes.default.string,
  secondConcentration: _propTypes.default.string,
  hasConcentrations: _propTypes.default.string,
  hasDiversity: _propTypes.default.string,
  lasLevelCompleted: _propTypes.default.string,
  hasResumeLevelsComplete: _propTypes.default.bool,
  typeSeeking: _propTypes.default.string,
  hasSeekingFirstJob: _propTypes.default.string,
  firstCollege: _propTypes.default.string,
  firstMajorCategory: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),
  firstMajorCategoryName: _propTypes.default.string,
  graduationMonth: _propTypes.default.string,
  graduationYear: _propTypes.default.string,
  firstMajorGPA: _propTypes.default.string,
  includeFirstMajorGPAOnResume: _propTypes.default.bool,
  firstMajorConcentration: _propTypes.default.string,
  firstMajorSecondConcentration: _propTypes.default.string,
  firstDegreeConcentration: _propTypes.default.string,
  firstDegreeSecondConcentration: _propTypes.default.string,
  otherFirstDegree: _propTypes.default.string,
  otherFirstMajorCategory: _propTypes.default.string,
  secondCollege: _propTypes.default.string,
  secondMajorCategory: _propTypes.default.string,
  secondMajorCategoryName: _propTypes.default.string,
  secondMajorMonth: _propTypes.default.string,
  secondMajorYear: _propTypes.default.string,
  secondMajorGPA: _propTypes.default.string,
  includeSecondMajorGPAOnResume: _propTypes.default.bool,
  secondMajorConcentration: _propTypes.default.string,
  secondMajorSecondConcentration: _propTypes.default.string,
  secondDegreeConcentration: _propTypes.default.string,
  secondDegreeSecondConcentration: _propTypes.default.string,
  otherSecondDegree: _propTypes.default.string,
  otherSecondMajorCategory: _propTypes.default.string,
  thirdMajor: _propTypes.default.string,
  thirdMajorCategory: _propTypes.default.string,
  thirdMajorCategoryName: _propTypes.default.string,
  thirdMajorGPA: _propTypes.default.string,
  includeThirdMajorGPAOnResume: _propTypes.default.bool,
  thirdMajorConcentration: _propTypes.default.string,
  thirdMajorSecondConcentration: _propTypes.default.string,
  otherThirdMajorDegree: _propTypes.default.string,
  otherThirdMajorCategory: _propTypes.default.string,
  internationalHome: _propTypes.default.oneOfType([_propTypes.default.bool, _propTypes.default.number]),
  honors: _propTypes.default.arrayOf(_honor.default),
  relevantCourseWorks: _propTypes.default.arrayOf(_relevantCoursework.default),
  studiesAbroad: _propTypes.default.arrayOf(_studyAbroad.default),
  enhancedAcademicExperiences: _propTypes.default.arrayOf(_enhancedAcademicExperience.default),
  languages: _propTypes.default.arrayOf(_language.default),
  d1Athletics: _propTypes.default.arrayOf(_d1Athletic.default),
  highSchoolHonors: _propTypes.default.arrayOf(_highSchoolHonor.default),
  minors: _propTypes.default.arrayOf(_minor.default),
  careers: _propTypes.default.arrayOf(_career.default),
  jobsInterest: _propTypes.default.arrayOf(_jobInterest.default),
  industries: _propTypes.default.arrayOf(_industry.default),
  scholarships: _propTypes.default.arrayOf(_scholarship.default),
  diversity: _propTypes.default.arrayOf(_diversity.default),
  preferences: _propTypes.default.arrayOf(_preference.default),
  pronouns: _pronouns.default,
  technicalSkill: _propTypes.default.arrayOf(_technicalSkill.default),
  personalInterests: _propTypes.default.arrayOf(_personalInterest.default),
  certificationsAndLicences: _propTypes.default.arrayOf(_certificationOrLicence.default),
  professionalExperiences: _propTypes.default.arrayOf(_professionalExperience.default),
  otherExperiences: _propTypes.default.arrayOf(_otherExperience.default),
  additionalInformation: _propTypes.default.arrayOf(_additionalInformation.default),
  links: _propTypes.default.arrayOf(_link.default),
  coursework: _propTypes.default.arrayOf(_coursework.default),
  beYourselfDAnswers: _question.default,
  beInformedAnswers: _question.default,
  bePreparedAnswers: _question.default,
  beProfessionalAnswers: _question.default,
  beInclusiveAnswers: _question.default,
  workEligibility: _workEligibility.default
});
exports.default = _default;